import { IsNotEmpty, ValidateIf, IsNumberString, Matches } from 'class-validator';
import { TenantDetailsValidatorIsPropertyUnique } from '../validators/TenantDetailsValidatorIsPropertyUnique';
import { TenantDetailsValidatorIsCloudIdUnique } from '../validators/TenantDetailsValidatorIsCloudIdUnique';
import { FormDataBase } from '@/common/form';

export class TenantDetailsFormDataTenant extends FormDataBase {

  @IsNotEmpty({ message: 'Tenancy Name is required' })
  @Matches(/^[a-zA-Z0-9&'()\-_ ]*$/, { message: 'Tenancy Name is invalid'})
  name: string = '';
  
  cloudHealthClientApiId: string = '';

  @TenantDetailsValidatorIsPropertyUnique({ message: 'Odin Account ID is not unique' })
  @IsNotEmpty({ message: 'Odin Account ID is required' })
  odinAccountId: string = '';

  @TenantDetailsValidatorIsPropertyUnique({ message: 'CIDN is not unique' })
  @IsNotEmpty({ message: 'CIDN is required' })
  cidn: string = '';

  @TenantDetailsValidatorIsPropertyUnique({ message: 'Odin PayTool ID is not unique' })
  @IsNotEmpty({ message: 'Odin PayTool ID is required' })
  odinPayToolId: string = '';

  isPartnerSalesChannel: boolean = false;

  accountManagerName: string = '';

  @ValidateIf((tenant: TenantDetailsFormDataTenant) =>
    (tenant!.isPartnerSalesChannel !== undefined && tenant.isPartnerSalesChannel))
  @IsNotEmpty({ message: 'Partner name is required' })
  partnerDealerCode: string = '';

  @TenantDetailsValidatorIsCloudIdUnique({ message: 'AWS Direct Master Payer Account ID is not unique' })
  @ValidateIf((tenant: TenantDetailsFormDataTenant) => tenant!.awsDirectMasterAccountId !== undefined)
  awsDirectMasterAccountId: string = '';

  @TenantDetailsValidatorIsCloudIdUnique({ message: 'Azure Tenant ID is not unique' })
  @ValidateIf((tenant: TenantDetailsFormDataTenant) => tenant!.cloudOrganizationId !== undefined &&
    (tenant!.authenticationDomain !== undefined && tenant.authenticationDomain.length > 0) ||
    (tenant!.azurePlanOdinSubscriptionId !== undefined && tenant.azurePlanOdinSubscriptionId.length > 0))
  @IsNotEmpty({ message: 'Tenant ID is required' })
  cloudOrganizationId: string = '';

  // Mandatory if cloudOrganizationId is populated
  @ValidateIf((tenant: TenantDetailsFormDataTenant) => (tenant!.cloudOrganizationId !== undefined && tenant.cloudOrganizationId.length > 0)
    || (tenant!.azurePlanOdinSubscriptionId !== undefined && tenant.azurePlanOdinSubscriptionId.length > 0))
  @IsNotEmpty({ message: 'Azure Domain is required' })
  authenticationDomain: string = '';

  dome9AccountId: string = '';

  @ValidateIf((e) => e.azurePlanOdinSubscriptionId && e.azurePlanOdinSubscriptionId.length > 0)
  @IsNumberString({}, { message: 'Azure Plan Odin Subscription ID can only contain numbers' })
  azurePlanOdinSubscriptionId: string = '';
}
